import classNames from 'classnames';
import './Col.scss';
import IColProps from './ColProps';

const Col = ({ size, xs, sm, md, lg, align, className, forwardRef, children }: IColProps) => {
  const classes = classNames(
    {
      col: true,
      [`col-${size}`]: size,
      [`col-xs-${xs}`]: xs,
      [`col-sm-${sm}`]: sm,
      [`col-md-${md}`]: md,
      [`col-lg-${lg}`]: lg,
      [`col-align-${align}`]: align,
    },
    className
  );

  return (
    <div ref={forwardRef} className={classes}>
      {children}
    </div>
  );
};

export default Col;
